export const myprofile = {
    title: 'ข้อมูลส่วนตัว',
    picture: {
        upload_picture: 'เลือกรูป',
        file_support: 'ไฟล์ที่รองรับ : JPEG,PNG',
    },
    storeId: {
        name: 'รหัสร้านค้า',
        placeholder: '',
        required: 'Please enter store ID',
        too_short: '',
        invalid: '',
    },
    storeName: {
        name: 'ชื่อร้านค้า',
        placeholder: '',
        required: 'Please enter store Name',
        too_short: '',
        invalid: '',
    },
    firstname: {
        name: 'ชื่อจริง',
        placeholder: '',
        required: 'Please enter firstname',
        too_short: '',
        invalid: '',
    },
    lastname: {
        name: 'นามสกุล',
        placeholder: '',
        required: 'Please enter lastname',
        too_short: '',
        invalid: '',
    },
    mobileNumber: {
        name: 'เบอร์โทรศัพท์ (มือถือ)',
        placeholder: '',
        required: 'Please enter mobile number',
        too_short: '',
        invalid: 'Please enter mobile number',
    },
    changeMobileNumber: {
        name: 'เบอร์โทรศัพท์ (มือถือ)',
        placeholder: '',
        required: 'Please enter mobile number',
        too_short: '',
        invalid: 'Please enter mobile number',
        change: 'เปลี่ยน',
    },
    email: {
        name: 'อีเมล์',
        placeholder: '',
        required: 'Please enter email',
        too_short: '',
        invalid: '',
    },
    store_type: 'ประเภทร้านค้า',
    btn_save: 'บันทึก',
    change_mobile_number: {
        title: 'เปลี่ยนเบอร์โทรศัพท์ (มือถือ)',
        msg: 'กรุณาระบุเบอร์โทรศัพท์มือถือที่ต้องการเปลี่ยนแปลง',
        confirm: 'ยืนยัน',
        close: 'ยกเลิก'
    }
}
